<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<p class="center"><a id="pi"></a><span class="big"><strong>BAND</strong> <span class="big1"><strong>OF</strong></span> <strong>SISTERS</strong></span></p>
<p class="center"><strong>American women at war in Iraq</strong><br/><br/><br/></p>
<p class="center"><img alt="" src="OEBPS/images/common.jpg"/><br/><br/><br/><br/></p>
<p class="center"><strong>KIRSTEN HOLMSTEDT</strong></p>
<p class="center"><strong><em>Foreword by Maj. L. Tammy Duckworth</em></strong><br/><br/><br/><br/><br/><br/><br/></p>
<p class="center"><span class="big2">STACKPOLE<br/>BOOKS</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780811740111_epub_tp_r1.vue?78b973cf